import { FC } from 'react'
import { CloseIcon } from '@components/icons/light'
import { cn } from '@utils'
import { toaster } from '@components/shared/toaster/toaster.ts'

interface NotificationBarProps {
  title: string
  message?: string
  variant: 'info' | 'success' | 'error'
}

const notificationIconMap = {
  info: '/images/icons/notification-info-icon.svg',
  success: '/images/icons/notification-success-icon.svg',
  error: '/images/icons/notification-error-icon.svg',
}

export const ToastBar: FC<NotificationBarProps> = ({ variant, title, message }) => {
  return (
    <div className="relative">
      <div
        className={cn('z-50 p-4 flex justify-start sm:justify-center', {
          'bg-cw-purple-bright': variant === 'info',
          'bg-cw-purple-dark/80': variant === 'success',
          'bg-cw-red-dark/80': variant === 'error',
        })}
        role="alert"
      >
        <div className="flex items-center gap-2 pr-[2rem]">
          <div className="min-w-[24px]">
            <img
              className="w-[1.6rem]"
              src={notificationIconMap[variant]}
              alt="notification-icon"
            />
          </div>

          <div className="pr-4 sm:pr-0">
            <div className="text-white font-semibold">{title}</div>
            {message && <div className="text-white font-normal mt-1">{message}</div>}
          </div>
        </div>

        <div
          className="absolute top-0 right-0 h-full w-[4rem] flex justify-center items-center cursor-pointer"
          onClick={toaster.dismissCurrent}
        >
          <CloseIcon className="w-5 h-5 text-white" />
        </div>
      </div>
    </div>
  )
}
